export default "__VITE_ASSET__CkHbnY$F__"